import { FormattedMessage } from "react-intl";
import { NoModelFoundIcon } from "../icons";
import { useWindowSize } from "hooks/useWindowSize";

export const NoModelFound = () => {
  const { width } = useWindowSize();
  return (
    <div className="flex flex-col gap-3 py-[32px] items-center text-center">
      <NoModelFoundIcon />
      <div className={`font-inter font-semibold text-[#737373] dark:text-[rgba(255,255,255,0.7)] ${width<=576 ? "text-[14px]": "text-[16px]"}`}>
        <FormattedMessage id="gptmodel.nomodelfound" />
      </div>
      <div className={`font-inter font-normal text-[#737373] dark:text-[rgba(255,255,255,0.7)] w-[300px] ${width<=576 ? "text-[12px]": "text-[14px]"}`}>
        <FormattedMessage id="gptmodel.nomodelfound.subtitle" />
      </div>
    </div>
  );
};
